export * from './tooltip';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/tooltip/index.js
// module id = 332
// module chunks = 0